import i18n from 'src/i18n';

export const useTranslationHook = (jsonString: string): string => i18n.t(jsonString);
